<template>
  <div class="container">
    <div class="temple">
      <div class="name">{{ templeName }}</div>
      <img src="@/assets/images/bg-temple-bottom.png" alt="" class="bottom" />
      <div class="items">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="item"
          @click="toItem(item)"
        >
          <div class="content">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- <div style="width: 100%; display: flex; justify-content: right">
      <div class="records" @click="toRecords">捐款记录</div>
    </div> -->
    <van-overlay
      style="display: flex; align-items: center; justify-content: center"
      :show="loading"
    >
      <van-loading color="#1989fa" />
    </van-overlay>
  </div>
</template>

<script>
import { decryptToken } from '@/utils/cryptoQrcode.js';
import { getProjectList, getTempleName } from '@/api/donate/index.js';
export default {
  name: '',
  components: {},
  data() {
    return {
      items: [],
      loading: false,
      templeName: '',
      organizationId: ''
    };
  },
  async created() {
    this.initPage();
    const res = await getTempleName({
      organizationId: this.organizationId
    });
    if (res.code === 0 && res.data) {
      this.templeName = res.data.name;
    } else {
      this.templeName = '暂无名称';
    }
    await this.getList();
  },
  mounted() {},
  methods: {
    async initPage() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const encryptedToken = urlParams.get('organizationId');

        const payload = decryptToken(encryptedToken);

        this.organizationId = payload.organizationId;
      } catch (error) {
        console.error('页面初始化失败:', error);
      }
    },
    async getList() {
      try {
        this.loading = true;
        const res = await getProjectList({
          organizationId: this.organizationId
        });
        if (res.code === 0) {
          this.items = res.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    toRecords() {
      this.$router.push({
        name: 'DonateRecords'
      });
    },
    toItem(item) {
      this.$router.push({
        name: 'DonateOperate',
        query: {
          item: JSON.stringify(item),
          organizationId: this.organizationId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #efe2c6;
  padding-bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
  .temple {
    width: 343px;
    height: 580px;
    opacity: 1;
    background: #fbf4e2;
    background-image: url('~@/assets/images/bg-temple.png');
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    .name {
      width: 293px;
      height: 48px;
      background-image: url('~@/assets/images/bg-temple-name.png');
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      margin: 40px auto;
      margin-bottom: 0;
      color: #ab3a2a;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 10px;
      text-indent: 10px;
      text-align: center;
    }
    .bottom {
      width: 301.77px;
      height: 11px;
      margin-top: 10px;
    }
    .items {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(3, 84px); // 3列，每列84px
      gap: 24px 20px;
      justify-content: start; // 默认左对齐
      margin-top: 35px;
      box-sizing: border-box;
      padding: 0 25.5px;
      grid-template-rows: repeat(auto-fill, 187px); // 明确指定行高
      // 当 item 数量 ≤ 3 时居中
      &.items-center {
        justify-content: center;
        align-items: center;
        margin-top: 0;
      }

      .item {
        width: 84px;
        height: 187px;
        background-image: url('~@/assets/images/bg-temple-item.png');
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        padding-top: 20px;
        box-sizing: border-box;
        .content {
          writing-mode: vertical-lr; // 纵向从左到右
          width: 43px;
          height: 100px;
          color: #fff0a5;
          font-size: 16px;
          font-weight: 700;
          font-family: 'PingFang SC';
          text-align: center;
          line-height: 18.5px;
          letter-spacing: 4px;
          display: flex;
          align-items: center;
          overflow-y: auto; // 超出高度时自动换行
          word-wrap: break-word; // 允许长单词换行
          // 顶部对齐相关样式
          text-align: left; // 纵向排列时，left 对应顶部
          vertical-align: top; // 垂直对齐顶部
          // 可选：隐藏滚动条
          &::-webkit-scrollbar {
            display: none;
          }
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      }
    }
  }
  .records {
    margin-top: 24px;
    width: 127.5px;
    height: 40px;
    background-image: url('~@/assets/images/bg-temple-records.png');
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    font-family: 'PingFang SC';
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
